import {
  Account,
  accountSchema,
  CustomError,
  deserializeData
} from '@apeiron/temp'
import { useLazyQuery } from '@apollo/client'
import { ERROR_CODE } from '@src/constants/error'
import graphql from '@src/graphql/query/verifyAccount'
import { pRetry } from '@src/util/tools/retry'
import * as R from 'ramda'
import { useCallback } from 'react'

const useVerifyAccount = (): Hook => {
  const [query] = useLazyQuery(graphql)

  const doVerify = useCallback(
    async (passCondition?: (account: Account) => boolean): Promise<boolean> => {
      const response = await query()

      const account = deserializeData<Account>(response, accountSchema)

      const pass =
        account && passCondition ? passCondition(account) : !R.isNil(account)

      if (!pass) {
        throw new CustomError(
          'wait for operation result',
          ERROR_CODE.CONTRACT.WAIT_SEND_OPERATION_RESULT
        )
      }

      return true
    },
    [query]
  )

  const verify = useCallback(
    async (passCondition?: (account: Account) => boolean): Promise<boolean> => {
      try {
        await pRetry(async () => {
          await doVerify(passCondition)
        })

        return true
      } catch (error) {
        return false
      }
    },
    [doVerify]
  )

  return { verify }
}

type Hook = {
  verify: (passCondition?: (account: Account) => boolean) => Promise<boolean>
}

export default useVerifyAccount
